(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccc-infinate-image-scroll"] && !Shopify.designMode) return;
  try {
    
const loadEndlessSection = () => {
  const section = document.querySelector('.endless-section');
  if (section) {
    const isFullscreen = section.dataset.fullscreen === 'true';
    if (isFullscreen) {
      section.classList.add('fullscreen');
      document.body.classList.add('endless-no-scroll');
    }

    setTimeout(() => {
      const swiper = new Swiper(".endless-slider-container", {
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        spaceBetween: 0,
        direction: 'vertical',
        mousewheel: true,
        freeMode: true,
        speed: 12000,
        noSwipingClass: '_swiper-no-swiping',
        breakpoints: {
          768: {
            direction: 'horizontal',
            spaceBetween: 0,
            noSwipingClass: 'swiper-no-swiping'
          }
        }
      });

      let timeout = null;
      let captime = null;
      let isTouch = false;

      swiper.on('slideChange', () => {
        const caption = document.querySelector('.swiper-slide-active')?.getAttribute('data-caption') || '';
        document.querySelector('.endless-caption').innerHTML = caption;
      });

      swiper.on('slideChangeTransitionEnd', () => {
        if (isTouch) return;
        const caption = document.querySelector('.swiper-slide-next')?.getAttribute('data-caption') || '';
        if (captime) clearTimeout(captime);
        captime = setTimeout(() => {
          document.querySelector('.endless-caption').innerHTML = caption;
        }, 6000);
        swiper.slideNext();
      });

      section.querySelector('.endless-slider-container').style.opacity = 1;

      section.querySelector('.endless-slider-container').addEventListener('wheel', interact);
      swiper.on('touchStart', () => { isTouch = true; });
      swiper.on('touchEnd', () => { isTouch = false; interact(); });

      function interact() {
        const caption = document.querySelector('.swiper-slide-active')?.getAttribute('data-caption') || '';
        document.querySelector('.endless-caption').innerHTML = caption;
        if (timeout) clearTimeout(timeout);
        if (captime) clearTimeout(captime);
        timeout = setTimeout(() => {
          swiper.animating = false;
          swiper.slideNext();
        }, 250);
      }

      swiper.slideNext();
    }, 500);
  }
};

document.addEventListener('shopify:section:load', () => {
  loadEndlessSection();
});

loadEndlessSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["endless"] && !Shopify.designMode) return;
  try {
    
(() => {
  const speedMap = { slow: 1, medium: 2, fast: 4 };
  const isVertical = () => window.innerWidth <= 767;
  const axis = () => (isVertical() ? 'y' : 'x');

  // Shopify best-practice (when keeping everything inside the section):
  // - Load vendor scripts via <script src ... defer> in the markup (your section already does this)
  // - Do NOT dynamically inject scripts from JS (avoids duplicate loads + editor quirks)
  // - Just wait until the globals exist, then init.
  function waitForEmblaGlobals({ timeoutMs = 12000 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const tick = () => {
        const ok =
          typeof window.EmblaCarousel === 'function' &&
          typeof window.EmblaCarouselAutoScroll === 'function';

        if (ok) return resolve();
        if (Date.now() - start > timeoutMs) {
          return reject(
            new Error(
              'Embla globals not available. (EmblaCarousel / EmblaCarouselAutoScroll missing)'
            )
          );
        }
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  // Track instances so Theme Editor re-renders don't double-init
  const instances = new WeakMap();

  function initSection(section) {
    if (!section || section.nodeType !== 1) return;

    // If already initialised, destroy first
    const existing = instances.get(section);
    if (existing?.destroy) existing.destroy();

    const viewport = section.querySelector('[data-endless-viewport]');
    const captionBox = section.querySelector('[data-endless-caption]');

    if (!viewport) {
      console.warn('[Endless] Missing viewport element');
      return;
    }

    let emblaApi = null;
    let currentAxis = axis();
    let resizeRaf = null;
    let scrollTicking = false;
    let observer = null;

    function getSpeed() {
      return speedMap[section.dataset.speed] ?? 2;
    }

    function applyFullscreen() {
      const on = section.dataset.fullscreen === 'true';
      section.classList.toggle('fullscreen', on);
      document.body.classList.toggle('endless-no-scroll', on);
    }

    function updateCaption() {
      if (!captionBox || !emblaApi) return;
      const inView = emblaApi.slidesInView(true);
      const idx = inView.length ? inView[0] : emblaApi.selectedScrollSnap();
      const node = emblaApi.slideNodes()[idx];
      captionBox.textContent = node?.dataset?.caption || '';
    }

    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => {
        scrollTicking = false;
        updateCaption();
      });
    }

    function destroyEmbla() {
      if (!emblaApi) return;
      try { emblaApi.off('scroll', onScroll); } catch (_) {}
      try { emblaApi.destroy(); } catch (_) {}
      emblaApi = null;
    }

    function buildEmbla() {
      destroyEmbla();
      currentAxis = axis();

      const autoScroll = window.EmblaCarouselAutoScroll({
        speed: getSpeed(),
        direction: 'forward',
        startDelay: 0,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        stopOnFocusIn: true
      });

      const wheel = typeof window.EmblaCarouselWheelGestures === 'function'
        ? window.EmblaCarouselWheelGestures({
            // Map vertical mouse wheel / trackpad scroll to the carousel
            forceWheelAxis: 'y',
            // Listen on the viewport (so it only reacts when hovering the carousel)
            target: viewport
          })
        : null;

      emblaApi = window.EmblaCarousel(
        viewport,
        {
          loop: true,
          dragFree: true,
          axis: currentAxis,
          align: 'start'
        },
        [autoScroll, ...(wheel ? [wheel] : [])]
      );

      updateCaption();
      emblaApi.on('scroll', onScroll);
      emblaApi.on('reInit', updateCaption);
    }

    function bindResize() {
      window.addEventListener('resize', () => {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(() => {
          const nextAxis = axis();
          if (nextAxis !== currentAxis) buildEmbla();
        });
      });
    }

    function bindAttributeObserver() {
      observer = new MutationObserver((muts) => {
        muts.forEach((m) => {
          if (m.type !== 'attributes') return;
          if (m.attributeName === 'data-speed') buildEmbla();
          if (m.attributeName === 'data-fullscreen') applyFullscreen();
        });
      });

      observer.observe(section, {
        attributes: true,
        attributeFilter: ['data-speed', 'data-fullscreen']
      });
    }

    function destroy() {
      observer?.disconnect?.();
      destroyEmbla();
    }

    // Kick off
    applyFullscreen();
    buildEmbla();
    bindResize();
    bindAttributeObserver();

    instances.set(section, { destroy });
  }

  async function initAll(root = document) {
    await waitForEmblaGlobals();
    root.querySelectorAll('.endless-section').forEach(initSection);
  }

  // Run on initial page load
  const start = () => initAll().catch((err) => {
    console.error('[Endless] init failed:', err);
    // If this fires, it usually means the CDN scripts are blocked (CSP) or failed to load.
    // Best-practice fix: host embla UMD files in theme assets and load via asset_url.
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Shopify Theme Editor: section gets injected/re-rendered without full reload
  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target).catch((err) => console.error('[Endless] init failed:', err));
  });

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.endless-section').forEach((section) => {
      const inst = instances.get(section);
      if (inst?.destroy) inst.destroy();
      instances.delete(section);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
